import { render } from "./TableFooterIndicator.vue?vue&type=template&id=485391e8"
import script from "./TableFooterIndicator.vue?vue&type=script&lang=js"
export * from "./TableFooterIndicator.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__